(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-image-gallery-carousel').each(function () {
			const carousel = $(this);
			const layout = carousel.data('layout');
			const sliderEl = $('.swiper', carousel)[0];
			const navParent = $('.js-image-gallery-carousel-nav', carousel).parent();

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 20,
				slidesPerView: 1,
				loop: true,
				autoHeight: true,
				effect: layout === 'slider' ? 'slide' : 'fade',

				pagination: {
					el: $('.js-carousel-nav-pagination', carousel)[0],
					clickable: true,
					renderBullet: function (index, className) {
						return '<span class="carousel-nav__bullet ' + className + '">' + (index + 1) + '</span>';
					},
				},

				navigation: {
					nextEl: $('.js-carousel-nav-next', carousel)[0],
					prevEl: $('.js-carousel-nav-prev', carousel)[0],
				},

				breakpoints: {
					744: {
						slidesPerView: layout === 'slider' ? 2 : 1,
						spaceBetween: 30,
					},
					1280: {
						slidesPerView: layout === 'slider' ? 2 : 1,
						spaceBetween: 40,
					},
				},

				on: {
					beforeInit: function () {
						let numSlides = this.wrapperEl.querySelectorAll( '.js-carousel-slide' ).length;
						if ( numSlides <= 4 ) {
							this.params.loop = false;
						}
					}
				}
			});
		});
	});
})(jQuery, document, window);